module.exports = __webpack_public_path__ + "static/media/Ron Weasley 2.31bcd0e1.jpg";